import { Icon } from '@/components/Icon';
import { cn } from '@/lib/cn';

/** The one answer for a guest whose code will not scan, shared by the landing page and the "no session" screen. */
export function CantScanCard({ className }: { className?: string }) {
  return (
    <div
      className={cn(
        'flex w-full max-w-lg items-start gap-3 rounded-surface border border-line bg-white px-4 py-3 text-left shadow-card',
        className,
      )}
    >
      <span className="grid size-9 shrink-0 place-items-center rounded-full bg-primary-soft text-primary">
        <Icon name="bell" size={18} />
      </span>
      <p className="text-sm text-muted">
        <strong className="block font-semibold text-ink">Can&apos;t scan the code?</strong>
        Ask any member of staff and they will get you started.
      </p>
    </div>
  );
}
